import React from 'react'
import { UseOfStatus } from '@/pages/communal/statistics/components/common/data'
import { UseOfStatusChart } from './UseOfStatusChart'
import { HelpPopupButton } from '@/popups/helppopup/help'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { useTranslations } from '@/hooks/useTranslations'

type UseOfStatusBoxProps = {
  services: Services
  session: CurrentSession
  status: UseOfStatus
}

export const UseOfStatusBox = ({ services, session, status }: UseOfStatusBoxProps) => {
  const translates = useTranslations(services, session)

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return (
    <div>
      <HelpPopupButton helpKey='page.statistics.global.box.useofmachine.help' translates={translates}/>
      <UseOfStatusChart
        status={status}
        chartTitle={translates.for('page.statistics.global.box.useofmachine.title')}
        translationsKey='page.statistics.global.box.useofmachine.data_label'
        translates={translates}
      />
    </div>
  )
}